import {gql} from "@apollo/client";

export const GET_INCIDENT_TYPES = gql`
  query GetIncidentTypes {
    types(orderBy: {name: asc}) {
      id
      name
      description
      backgroundColor
      foregroundColor
      isDeleted
      inUseBy {
        model
        count
      }
    }
  }
`;
export const CREATE_INCIDENT_TYPE = gql`
  mutation CreateIncidentType(
    $name: String!
    $description: String
    $backgroundColor: String
    $foregroundColor: String
  ) {
    createOneType(
      data: {
        name: $name
        description: $description
        backgroundColor: $backgroundColor
        foregroundColor: $foregroundColor
      }
    ) {
      id
      name
      description
      backgroundColor
      foregroundColor
      isDeleted
    }
  }
`;
export const UPDATE_INCIDENT_TYPE = gql`
  mutation UpdateIncidentType(
    $id: Int!
    $name: String!
    $description: String
    $backgroundColor: String
    $foregroundColor: String
  ) {
    updateOneType(
      where: {id: $id}
      data: {
        name: {set: $name}
        description: {set: $description}
        backgroundColor: {set: $backgroundColor}
        foregroundColor: {set: $foregroundColor}
      }
    ) {
      id
      name
      description
      backgroundColor
      foregroundColor
      isDeleted
    }
  }
`;
export const SOFT_DELETE_INCIDENT_TYPE = gql`
  mutation SoftDeleteIncidentType($id: Int!) {
    deleteOneType(where: {id: $id}) {
      id
      name
      description
      backgroundColor
      foregroundColor
      isDeleted
    }
  }
`;
